import React from "react";
import { Navigate } from "react-router-dom";
import { getUser } from "./Common";

// handle the private routes
function PrivateRoute({ children }) {
  var isUser = false;
  const user = getUser();
  if (user) {
    const role = user.user_type;
    if (role === 2) {
      isUser = true;
    }
  }

  // return isUser ? children : <Navigate to="/login" />;
  return isUser ? children : <Navigate to="/" />;
}

export default PrivateRoute;
